import type {InteractionVisualStateRuntime} from './AbstractInteractionVisualState';
import type {Viewer} from '../../viewer/Viewer';
import {SketchDefaultTransitionState} from './SketchDefaultTransitionState';

/**
 * 圆周草图阵列视觉状态。
 *
 * 阵列命令仍处于活动草图编辑会话内，复用草图默认实体材质与选择状态；
 * 阵列预览的临时视觉层级由控制器统一管理。
 */
export class SketchCircularPatternTransitionState extends SketchDefaultTransitionState {
    /**
     * 创建圆周草图阵列视觉状态。
     *
     * @param runtime 交互视觉运行时。
     * @param viewer Viewer 实例。
     */
    public constructor(runtime: InteractionVisualStateRuntime, viewer: Viewer) {
        super(runtime, viewer);
    }
}
